import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"

export interface BetterLogoMarkProps {
  className?: string
}

const BetterLogoMark: React.FC<BetterLogoMarkProps> = ({ className }) => {
  return (
    <svg
      className={cx({
        [styles.logoMark]: true,
        [className]: !!className,
      })}
      height="422"
      viewBox="0 0 500 422"
      width="500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m338.095506 332.533132 161.698055 89.466868.206439-222.718187-161.749665-93.590845zm-172.268671-332.533132 176.617966 81.3876223-166.263172 117.6692467-.211131 222.718187-175.970498-82.437362.15482927-220.76867z"
        fill="#37ebc2"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default BetterLogoMark
